import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ClientDashboardComponent } from './client-dashboard.component';
import { ReportsComponent } from '../reports/reports.component';
import { LogComponent } from '../log/log.component'
import { AuthGuard } from 'src/app/config/auth.guard';
import { OverviewComponent } from './overview/overview.component';
import { CyclesComponent } from './cycels/cycles.component';
import { SensorsComponent } from './sensors/sensors.component';
import { AppliancesComponent } from './appliances/appliances.component';
import { GatewaysComponent } from './gateways/gateways.component';

const routes: Routes = [
    {
        path: 'client-dashboard/:id',
        component: ClientDashboardComponent,
        canActivate: [AuthGuard],
        children: [
            {
                path: 'overview',
                component: OverviewComponent,
            },
            {
                path: 'cycles',
                component: CyclesComponent,
            },
            {
                path: 'sensors',
                component: SensorsComponent,
            },
            {
                path: 'appliances',
                component: AppliancesComponent,
            },
            {
                path: 'gateways',
                component: GatewaysComponent,
            },
            {
                path: '**',
                redirectTo: 'overview'
            }


        ]
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})

export class ClientDashboardRoutingModule { }